/**
 * <kyn-drop-hero data-drop-ts="<epoch seconds>" data-state="pre|live">
 * Ticks the countdown every second. Past the drop date the element flips to
 * the live state: no timer, live kicker and live CTA.
 */
class KynDropHero extends HTMLElement {
  /** @type {number | undefined} */
  #interval;

  connectedCallback() {
    this.querySelector('[data-newsletter-link]')?.addEventListener('click', this.#toNewsletter);
    this.#tick();
    if (this.dataset.state === 'live') return;
    this.#interval = window.setInterval(() => this.#tick(), 1000);
  }

  disconnectedCallback() {
    window.clearInterval(this.#interval);
  }

  /**
   * Scrolls to the footer newsletter field and puts the cursor in it.
   * scrollIntoView, because on desktop `.page-wrapper` scrolls instead of the window.
   * @param {MouseEvent} event
   */
  #toNewsletter = (event) => {
    const input = document.querySelector('.email-signup-block input[type="email"]');
    if (!(input instanceof HTMLInputElement)) return;
    event.preventDefault();
    input.scrollIntoView({ behavior: 'smooth', block: 'center' });
    input.focus({ preventScroll: true });
  };

  #tick() {
    const target = Number(this.dataset.dropTs);
    if (!Number.isFinite(target) || target <= 0) return;

    let left = Math.max(0, Math.floor(target - Date.now() / 1000));
    if (left === 0) {
      this.dataset.state = 'live';
      window.clearInterval(this.#interval);
    }

    const days = Math.floor(left / 86400);
    left -= days * 86400;
    const hours = Math.floor(left / 3600);
    left -= hours * 3600;
    const minutes = Math.floor(left / 60);
    left -= minutes * 60;

    const pad = (/** @type {number} */ n) => String(n).padStart(2, '0');
    const values = { days: pad(days), hours: pad(hours), minutes: pad(minutes), seconds: pad(left) };

    for (const [key, value] of Object.entries(values)) {
      const cell = this.querySelector(`[data-unit="${key}"]`);
      if (cell && cell.textContent !== value) cell.textContent = value;
    }
  }
}

if (!customElements.get('kyn-drop-hero')) {
  customElements.define('kyn-drop-hero', KynDropHero);
}
